import Form, { Header, Input, Label, Select } from "../Forms/SmartForm";
import GoogleRecaptcha from "react-google-invisible-recaptcha";
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Modal from "../Modal/Modal";
import countries from "../../../libs/data/countries.json";
import jobTitles from "../../../libs/data/jobTitles.json";

const ModalGate = (props) => {
    const {
        dataAttribute = "",
        modalHeaderContent = null,
        buttonContent = null,
        gatedCtaContent = null,
        clickOpenModalEventName = "",
        clickCloseModalEventName = "",
    } = props;

    const siteFullName = "Lab Manager";
    let siteKey = "";
    if (typeof localStorage !== "undefined") {
        siteKey = localStorage.getItem("recaptchaSiteKey");
    }

    const form = useRef();
    const reCaptchaRef = useRef();
    const [displayFormModal, setDisplayFormModal] = useState({
        display: false,
        error: false,
    });
    const [jobTitle, setJobTitle] = useState("");
    const [disable, setDisable] = useState(false);


    const buttonTimeOut = () => {
        document.getElementById("btnClick");
        const validationEmail = document.forms["form"]["email"].value;
        const validationCountry = document.forms["form"]["lmg_demo_country"].value;
        if(validationEmail && validationCountry != ""){
            setDisable(true);
        }
    };

    const openModal = () => {
        // Push datalayer event for tracking within Google Analytics (GTM)
        window.dataLayer.push({
            "event": clickOpenModalEventName,
            "gtmCustomClick": {
                "eventCategory": "Conversion"
            }
        });

        // Display form modal
        setDisplayFormModal( (prev) => ({
            ...prev,
            display: true,
        }));
    };

    const closeModal = (event) => {
        event.stopPropagation();
        // Push datalayer event for tracking within Google Analytics (GTM)
        window.dataLayer.push({
            "event": clickCloseModalEventName,
            "gtmCustomClick": {
                "eventCategory": "Conversion"
            }
        });

        // Close form modal
        setDisplayFormModal( (prev) => ({
            ...prev,
            display: false,
        }));
    };

    const onSubmit = async (recaptcha) => {
        const formValues = form.current.getValuesAsObject();

        setDisplayFormModal((prev) => ({
            ...prev,
            error: false,
        }));

        try {
            await axios.post("/api/validate-modal-form", {
                formValues,
                recaptcha,
            });
            setDisplayFormModal((prev) => ({
                ...prev,
                display: false,
            }));
            setDisable(false);
        } catch (error) {
            if (!error.response) {
                error.response = {
                    data: {
                        errors: [error.message],
                    },
                };
            }
            const data = error.response.data;
            if (data.errors) {
                setDisplayFormModal((prev) => ({
                    ...prev,
                    error: data.errors.join("<br />"),
                }));
                if (data.fieldErrors) form.current.setAllErrors(data.fieldErrors);
                if (data.fieldValues) form.current.setValues(data.fieldValues);
            } else {
                setDisplayFormModal((prev) => ({
                    ...prev,
                    error: `${error.response.status}: ${error.response.text}`,
                }));
            }
        }

        props.onSubmit(formValues);
    };

    const validateRecaptcha = (e) => {
        e.preventDefault();
        reCaptchaRef.current.execute();
    };

    const ModalForm = () => {
        return (
            <Modal>
                <div className="modal-gate">
                    <div className="button-wrapper">
                        <button
                            type="button"
                            className="close-btn corner background-transparent no-border text-white float-right"
                            onClick={(e) =>closeModal(e)}
                        >
                            Cancel X
                        </button>
                    </div>
                    <div className="modal-gate-content m-0">
                        <Header className="p-v-1 p-h-2 m-b-0 text-center">
                            {modalHeaderContent()}
                        </Header>
                        <Form
                            id="gate-form"
                            className="p-v-1 p-h-2"
                            onSubmit={validateRecaptcha}
                            contextRef={form}
                            defaults={{ country: "CA" }}
                            name="form"
                        >
                            {displayFormModal.error && (
                                <div className="alert italic">
                                    <p>{displayFormModal.error}</p>
                                </div>
                            )}
                            <div className="form-row two-items">
                                <div className="form-group">
                                    <Label input="firstname">First Name</Label>
                                    <Input
                                        type="text"
                                        name="firstname"
                                        label="First Name"
                                        className="form-control border-light-grey m-b-1"
                                    />
                                </div>
                                <div className="form-group">
                                    <Label input="lastname">Last Name</Label>
                                    <Input
                                        type="text"
                                        name="lastname"
                                        label="Last Name"
                                        className="form-control border-light-grey m-b-1"
                                    />
                                </div>
                            </div>
                            <Label input="email" required>
                                Email Address
                            </Label>
                            <Input
                                type="email"
                                name="email"
                                label="Email Address"
                                className="form-control border-light-grey m-b-1"
                                required
                            />
                            {dataAttribute === "play-audio-article" && <>
                                <Label input="phone">
                                Phone
                                </Label>
                                <Input
                                    type="tel"
                                    name="phone"
                                    label="Phone"
                                    className="form-control border-light-grey m-b-1"
                                />
                            </>}
                            <Label input="lmg_demo_country" required>
                                Country
                            </Label>
                            <Select
                                name="lmg_demo_country"
                                className="m-b-1 border-light-grey"
                                label="Country"
                                required
                            >
                                <option hidden value="">
                                    Select
                                </option>
                                {countries.map(({ name, code }) => (
                                    <option key={code} value={code}>
                                        {name}
                                    </option>
                                ))}
                            </Select>
                            <div
                                className={
                                    "form-row" +
                                    (jobTitle == "Other" && " two-items")
                                }
                            >
                                {/** Only if user select "Other", we would then show Other text field for job title*/}
                                <div className="form-group">
                                    <Label input="demo_job_title">
                                        Job Title
                                    </Label>
                                    <Select
                                        name="demo_job_title"
                                        label="demo_job_title"
                                        className="m-b-1 border-light-grey"
                                        onChange={(event) =>
                                            setJobTitle(event.target.value)
                                        }
                                    >
                                        <option hidden value="">
                                            Select
                                        </option>
                                        {jobTitles.map(
                                            (jobTitle) => (
                                                <option
                                                    key={jobTitle}
                                                    value={jobTitle}
                                                >
                                                    {jobTitle}
                                                </option>
                                            )
                                        )}
                                    </Select>
                                </div>
                                {jobTitle == "Other" && (
                                    <div className="form-group">
                                        <Label input="demo_job_title_other">
                                            Other
                                        </Label>
                                        <Input
                                            type="text"
                                            name="demo_job_title_other"
                                            label="Other"
                                            className="form-control border-light-grey m-b-1"
                                        />
                                    </div>
                                )}
                            </div>
                            {dataAttribute === "play-audio-article" && <>
                                <Label input="opted_in__lm_third_party_email_subscription_page_only">
                                Would you like to receive information from{" "}
                                    <em>{siteFullName}’s</em> Trusted Sponsors.
                                </Label>
                                <Select
                                    name="opted_in__lm_third_party_email_subscription_page_only"
                                    className="border-light-grey m-b-1"
                                >
                                    <option hidden value="">
                                        Select
                                    </option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </Select>
                            </>}
                            <Label input="explicit_consent_confirmed">
                                Would you like to receive news updates and
                                relevant promotional content from{" "}
                                <em>{siteFullName}</em>?
                            </Label>
                            <Select
                                name="explicit_consent_confirmed"
                                className="border-light-grey m-b-1"
                            >
                                <option hidden value="">
                                    Select
                                </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </Select>
                            <button
                                type="submit"
                                className="btn brandedButton compact"
                                data-attribute={dataAttribute}
                                id="btnClick"
                                disabled={disable}
                                onClick={() => setTimeout(buttonTimeOut, 100)}
                            >
                                { buttonContent(true, dataAttribute) }
                            </button>
                            <button
                                className="close-btn in-form no-border"
                                onClick={(e) => closeModal(e)}
                            >
                                Cancel
                            </button>
                            <GoogleRecaptcha
                                ref={reCaptchaRef}
                                sitekey={siteKey}
                                onResolved= {onSubmit}
                            />
                        </Form>
                        <div className="form-footer background-white text-center p-v-1 p-h-2">
                            <p className="m-t-0 m-b-1">
                                <em>{siteFullName}</em> needs the
                                contact information you provide to us to contact
                                you about our products and services. You may
                                unsubscribe from these communications at any
                                time.
                            </p>
                            <p className="m-0">
                                For information on how to unsubscribe, as well
                                as our privacy practices and commitment to
                                protecting your privacy, check out our{" "}
                                <a href="/privacy-policy">Privacy Policy</a>.
                            </p>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    return (
        <>
            {dataAttribute ===  "play-audio-article" ? (
                <div id="ModalGate"  data-attribute={dataAttribute} onClick={openModal}>
                    {displayFormModal.display && ModalForm()}
                    {gatedCtaContent}
                </div>
            ) : (
                <div id="ModalGate">
                    {displayFormModal.display && ModalForm()}
                    <button
                        className="btn brandedButton compact"
                        data-attribute={dataAttribute}
                        onClick={openModal}
                    >
                        {buttonContent(false, dataAttribute)}
                    </button>
                </div>
            )}
        </>
    );
};

export default ModalGate;